export const { log, error } = console;
